// Non-secret pending-payment context for the resident top-up flow — survives
// a page refresh between "Paystack redirected away" and "Paystack redirected
// back" so polling can resume without the resident losing their place.
// Never store secrets, tokens, or raw provider payloads here.

const PENDING_PAYMENT_KEY = "OVEND_RESIDENT_PENDING_PAYMENT";
const MAX_PENDING_AGE_MS = 30 * 60 * 1000; // 30 minutes

export const getStoredPendingPayment = () => {
  try {
    const raw = localStorage.getItem(PENDING_PAYMENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.billId || !parsed?.createdAt) return null;

    if (Date.now() - parsed.createdAt > MAX_PENDING_AGE_MS) {
      clearStoredPendingPayment();
      return null;
    }
    return parsed;
  } catch (_) {
    return null;
  }
};

export const setStoredPendingPayment = ({ billId, reference }) => {
  try {
    localStorage.setItem(
      PENDING_PAYMENT_KEY,
      JSON.stringify({ billId, reference, createdAt: Date.now() }),
    );
  } catch (_) {
    // localStorage unavailable (private mode, quota) — resident can still
    // complete the flow via the Paystack redirect's own query params.
  }
};

export const clearStoredPendingPayment = () => {
  try {
    localStorage.removeItem(PENDING_PAYMENT_KEY);
  } catch (_) {
    // ignore
  }
};
